import React from 'react'

import { Link } from '@application/Interfaces/Atoms/Link'
import { CardType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Body, Button, Footer, Header, Image, ItemContainer, Label, Title, Value, Wrapper } from './Card.styled'

export const Card = (props: CardType): JSX.Element => {
    const {
        title,
        image,
        imageAnimation,
        label1,
        value1,
        label2,
        value2,
        label3,
        value3,
        label4,
        value4,
        ctaLabel,
        catLink,
    } = props

    return (
        <Wrapper>
            <Header>
                <Image image={image} imageAnimation={imageAnimation} />
                <Title>{title}</Title>
            </Header>
            <Body>
                <Grid container alignItems="spacing-between" justifyContent="center" component={ItemContainer}>
                    <Grid item xs={6} component={Label}>
                        {label1}
                    </Grid>
                    <Grid item xs={6} component={Value}>
                        {value1}
                    </Grid>
                    {label2 && value2 && (
                        <>
                            <Grid item xs={6} component={Label}>
                                {label2}
                            </Grid>
                            <Grid item xs={6} component={Value}>
                                {value2}
                            </Grid>
                        </>
                    )}
                    {label3 && value3 && (
                        <>
                            <Grid item xs={6} component={Label}>
                                {label3}
                            </Grid>
                            <Grid item xs={6} component={Value}>
                                {value3}
                            </Grid>
                        </>
                    )}
                    {label4 && value4 && (
                        <>
                            <Grid item xs={6} component={Label}>
                                {label4}
                            </Grid>
                            <Grid item xs={6} component={Value}>
                                {value4}
                            </Grid>
                        </>
                    )}
                </Grid>
            </Body>
            {ctaLabel && catLink && (
                <Footer>
                    <Link to={catLink}>
                        <Button>{ctaLabel}</Button>
                    </Link>
                </Footer>
            )}
        </Wrapper>
    )
}
